import AuthPageContainer from './AuthPageContainer'

export default function install(Vue) {
  Vue.component('auth-page-container', AuthPageContainer)
}
